import React from "react";
import '../../App.css';

export default function Stations(){
    return <h1 className="stations">STATIONS</h1>;

}